import * as requestFromServer from './kurbanReportCrud';
import { kurbanReportSlice, callTypes } from './kurbanReportSlice';
import { actions as auth } from '../../../../../Auth/_redux/authRedux';
import { toastOption } from '../../../../../../../_metronic/_helpers/ToastHelpers';
import { toast } from 'react-toastify';

const { actions } = kurbanReportSlice;

export const fetchKurbanReports = (queryParams) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer.findKurbanReport(queryParams)
        .then(response => {
            const { data: { total_items, items } } = response.data;
            dispatch(actions.kurbanReportsFetched({ total_items, items }));
        }).catch(error => {
            if (!error.response) {
                toast.error("Gagak Terhubung ke Server", toastOption)
            } else if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            } else {
                error = error.response.data.message;
                dispatch(actions.catchError({ error, callType: callTypes.list }));
            }
        });
};

export const fetchKurbanReport = (id) => dispatch => {
    if (!id) {
        return dispatch(actions.kurbanReportFetched({ kurbanReportForEdit: undefined }));
    }

    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.getKurbanReportById(id)
        .then(response => {
            const { data: kurbanReportForEdit } = response.data; // alias data -> donatur
            dispatch(actions.kurbanReportFetched({ kurbanReportForEdit }));
        }).catch(error => {
            if (!error.response) {
                toast.error("Gagal Terhubung ke Server", toastOption)
            } else if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            } else {
                error = error.response.data.message;
                dispatch(actions.catchError({ error, callType: callTypes.list }));
            }
        });
};

export const createKurbanReport = (kurbanReportForCreation) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.createKurbanReport(kurbanReportForCreation)
        .then(response => {
            dispatch(actions.kurbanReportReload);
            return response.data;
        })
        .catch(error => {
            if (!error.response) {
                toast.error("Gagal Terhubung ke Server", toastOption)
            } else if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            } else {
                error = error.response.data.message;
                dispatch(actions.catchError({ error, callType: callTypes.list }));
            }
        });
};

export const updateKurbanReport = (kurbanReport) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.updateKurbanReport(kurbanReport)
        .then(response => {
            dispatch(actions.kurbanReportReload);
            return response.data;
        })
        .catch(error => {
            if (!error.response) {
                toast.error("Gagal Terhubung ke Server", toastOption)
            } else if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            } else {
                error = error.response.data.message;
                dispatch(actions.catchError({ error, callType: callTypes.list }));
            }
        });
};



export const updateStatusKurbanReport = (kurbanReport, uuid) => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer.updateStatusKurbanReport(kurbanReport, uuid)
        .then(response => {
            dispatch(actions.kurbanReportReload);
            return response.data;
        })
        .catch(error => {
            if (!error.response) {
                toast.error("Gagal Terhubung ke Server", toastOption)
            } else if (error.response.status === 401) {
                toast.error(error.response.data.message, toastOption);
                dispatch(auth.logout())
            } else {
                error = error.response.data.message;
                dispatch(actions.catchError({ error, callType: callTypes.list }));
            }
        });
};
